import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { selectIrisContent } from './fromState';

export const selectIsInitialCallClient = createSelector(
    // eslint-disable-line
    [selectIrisContent],
    (irisContent) => _get(irisContent, 'isInitialCallClient', false)
);
